import React from 'react';
export function MissionSection() {
  return <section id="mission" className="py-20 md:py-28 bg-white" data-id="element-348">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-349">
        <div className="mb-12" data-id="element-350">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-351">
            Our Mission
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-352" />
        </div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-353">
          <p data-id="element-354">
            We create honest education — so that knowledge builds
            responsibility.
          </p>

          <p data-id="element-355">
            We develop independent research — so that decisions are based on
            facts, not assumptions.
          </p>

          <p data-id="element-356">
            We foster awareness — so that risks are discussed openly and without
            stigma.
          </p>

          <p data-id="element-357">
            We build open dialogue — between players, businesses, experts,
            society, and the state.
          </p>

          <p data-id="element-358">We provide responsible support — to those who need it.</p>

          <p data-id="element-359">
            We work toward transparent outcomes — for the development of fair
            and responsible gambling in Ukraine.
          </p>

          <div className="pt-4 space-y-2" data-id="element-360">
            <p className="text-[#0A5E5C] font-serif font-semibold text-xl" data-id="element-361">
              This is a space of trust.
            </p>
            <p className="text-[#0A5E5C] font-serif font-semibold text-xl" data-id="element-362">
              This is a space of responsibility.
            </p>
            <p className="text-[#0A5E5C] font-serif font-bold text-2xl" data-id="element-363">
              This is the FAIR GAMING SPACE.
            </p>
          </div>
        </div>
      </div>
    </section>;
}